import {
  MenuItem,
  Select,
  Skeleton,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { MdOutlineEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import Pagination from "@mui/material/Pagination";
import { IoIosSearch } from "react-icons/io";
import YourGuestModal from "../Modal/YourGuestModal";
import { useDispatch, useSelector } from "react-redux";
import {
  view_guest,
} from "../Redux/Action/GuestAction";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../Modal/DeleteModal";
import EditModal from "../Modal/EditModal";
import { get_event } from "../Redux/Action/EventAction";
import notfound from "../assets/images/no-result.png";
import { useTranslation } from "react-i18next";
import { sendReviewRequest } from "../Redux/Action/ContactAction";
import useTitle from "../Hooks/useTitle";
import CircularProgress from "@mui/material/CircularProgress";

const YourGuests = ({ guest_id, event_id }) => {
  useTitle('Guest List')
  const [currentPage, setCurrentPage] = useState(1);
  const [cachedPages, setCachedPages] = useState({});
  const [displayModal, setDisplayModal] = useState(true);
  const [Opendel, setOpendel] = React.useState(false);
  const [selectedGuest, setSelectedGuest] = useState(null);
  const [Openedit, setOpenedit] = React.useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [search, setSearch] = useState("");
  const [accountType, setAccountType] = useState("All");
  const [eventName, setEventName] = useState("All Event");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const dispatch = useDispatch();
  const { t } = useTranslation("Your_guest");
  const { viewguest, loading } = useSelector((state) => state.Guest);
  const { viewevent } = useSelector((state) => state.Create);
  // const { review } = useSelector((state) => state.Contact);
  const [allGuests, setAllGuests] = useState([]);
  const [loadingGuests, setLoadingGuests] = useState(true);

  useEffect(() => {
    setAllGuests(viewguest);
  }, [viewguest]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // 500ms debounce

    return () => clearTimeout(timeoutId);
  }, [search]);
  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearch, accountType, eventName]);

  const handleChangeAccountType = (e) => {
    setAccountType(e.target.value);
  };
  const handleChangeEvent = (e) => {
    setEventName(e.target.value);
  };

  const handlereview = (guest_id, event_id) => {
    console.log(guest_id);
    setAllGuests((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        data: prev.data.data?.map((item) => {
          if (item.id === guest_id) {
            console.log(item);
            return {
              ...item,
              is_sent: true,
            };
          }
          return item;
        }),
      },
    }));

    dispatch(sendReviewRequest(guest_id, event_id));
  };

  useEffect(() => {
    dispatch(get_event());
    const filterAccountType = accountType === "All" ? null : accountType;
    const filterEventName = eventName === "All Event" ? null : eventName;

    if (!cachedPages[currentPage]) {
        setLoadingGuests(true);

      dispatch(
        view_guest(
          currentPage,
          debouncedSearch,
          filterAccountType,
          filterEventName,
          Openedit
        )
      ).then((res) => {
        setLoadingGuests(false);
        setCachedPages((prev) => ({
          ...prev,
          [currentPage]: res,
        }));
      });
    }
  }, [
    dispatch,
    currentPage,
    debouncedSearch,
    accountType,
    eventName,
    Openedit,
  ]);

  const navigate = useNavigate();

  const isXL = useMediaQuery("(min-width: 1280px)");

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    // dispatch(view_guest(value, debouncedSearch, accountType, eventName, Openedit)).then((res) => {
    //     setCachedPages((prev) => ({
    //         ...prev,
    //         [currentPage]: res,
    //     }
    //     ));
    // });
  };
  const handleadd = () => {
    navigate("/AddGuest");
  };
  const handledelete = () => {
    setOpendel(true);
  };
  const handleedit = (guest) => {
    setSelectedGuest(guest);
    setOpenedit(true);
  };

  return (
    <>
      <div className="grid gap-4  p-8 py-6 mt-[76px] sm:ml-[300px]">
        {isXL ? (
          <div className={`flex justify-between  items-center z-[1]`}>
            <div className="w-[30vw] ">
              <span className="font-[600] text-[26px]">{t("header")}</span>
            </div>
            <div className="flex flex-row gap-3 w-full justify-end items-center ">
              <div className="div flex w-full relative max-w-96 sm::order-2">
                <input
                  type="text"
                  placeholder={t("guest_search")}
                  className="h-[50px] rounded-[10px] pl-[42px] pr-2 text-[14px] text-[#131415] font-[500] w-full focus:outline-none focus:ring-0 focus:border-[#3686FF] "
                  onChange={handleSearch}
                  value={search}
                />
                <span className="absolute top-[15px] left-3 ">
                  <IoIosSearch size={22} />
                </span>
              </div>
              <div className="flex w-full max-w-96     gap-3 justify-end sm::order-3">
                <Select
                  className="  text-[14px]"
                  value={accountType}
                  displayEmpty
                  onChange={handleChangeAccountType}
                  renderValue={(selected) => {
                    return selected === "0"
                      ? "Demo"
                      : selected === "1"
                        ? "Event"
                        : "All";
                  }}
                  sx={{
                    border: "none",
                    borderRadius: "8px",
                    height: "50px",
                    fontSize: 14,
                    background: "white",
                    width: "100%",
                    minWidth: "100px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove the outline when focused
                    },
                    "& .MuiSelect-icon": {
                      color: "#000", // Customize the icon color if needed
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        marginTop: "7px",
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <MenuItem value="All" sx={{ fontSize: 14 }}>
                    All
                  </MenuItem>
                  <MenuItem value="0" sx={{ fontSize: 14 }}>
                    Demo{" "}
                  </MenuItem>
                  <MenuItem value="1" sx={{ fontSize: 14 }}>
                    Event
                  </MenuItem>
                </Select>

                <Select
                  className="text-[14px]"
                  value={eventName}
                  onChange={handleChangeEvent}
                  displayEmpty
                  renderValue={(selected) => {
                    const selectedevent =
                      viewevent &&
                      viewevent.data &&
                      viewevent.data.find((event) => event.id === selected);
                    return selectedevent ? selectedevent.name : "All Event";
                  }}
                  sx={{
                    border: "none",
                    borderRadius: "8px",
                    height: "50px",
                    fontSize: 14,
                    background: "white",
                    maxWidth: "250px",
                    minWidth: "200px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove the outline when focused
                    },
                    "& .MuiSelect-icon": {
                      color: "#000", // Customize the icon color if needed
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        marginTop: "7px",
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <MenuItem value={"All Event"} sx={{ fontSize: 14 }}>
                    All event
                  </MenuItem>
                  {viewevent &&
                    viewevent.data &&
                    viewevent.data.map((obj) => (
                      <MenuItem
                        key={obj.id}
                        value={obj.id}
                        sx={{ fontSize: 14 }}
                      >
                        {obj.name}
                      </MenuItem>
                    ))}
                </Select>
              </div>
              <button
                className="bg-[#3686FF] text-white rounded-lg  h-[50px]  w-full max-w-40 sm::order-1"
                onClick={handleadd}
              >
                {t("btn_guest")}
              </button>
            </div>
          </div>
        ) : (
          <div className="flex flex-col justify-between  w-full  gap-4 items-center z-[1]">
            <div className="w-full flex justify-between items-center">
              <span className="font-[600] text-[26px]">{t("header")}</span>
              <button
                className="bg-[#3686FF] text-white rounded-lg  h-[50px]  w-full max-w-40 "
                onClick={handleadd}
              >
                {t("btn_guest")}
              </button>
            </div>

            <div className="flex  flex-col gap-3 w-full  items-start  sm:flex-col lg:flex-row">
              <div className="div flex w-full relative ">
                <input
                  type="text"
                  placeholder="Search"
                  className="h-[50px] rounded-[10px] pl-[42px] pr-2 text-[14px] text-[#131415] font-[500] w-full max-w-96 focus:outline-none focus:ring-0 focus:border-[#3686FF] "
                  onChange={handleSearch}
                  value={search}
                />
                <span className="absolute top-[15px] left-3 ">
                  <IoIosSearch size={22} />
                </span>
              </div>
              {/* <div className="flex flex-col  gap-2  w-[70%] md:w-full sm:flex-col md:flex-row justiofy-start"> */}
              <div className="flex gap-2 w-full">
                <Select
                  className="  text-[14px]"
                  value={accountType}
                  displayEmpty
                  onChange={handleChangeAccountType}
                  renderValue={(selected) => {
                    return selected === "0"
                      ? "Demo"
                      : selected === "1"
                        ? "Event"
                        : "All";
                  }}
                  sx={{
                    border: "none",
                    borderRadius: "8px",
                    height: "50px",
                    fontSize: 14,
                    background: "white",
                    width: "100%",
                    minWidth: "50px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove the outline when focused
                    },
                    "& .MuiSelect-icon": {
                      color: "#000", // Customize the icon color if needed
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        marginTop: "7px",
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <MenuItem value="All" sx={{ fontSize: 14 }}>
                    All
                  </MenuItem>
                  <MenuItem value="0" sx={{ fontSize: 14 }}>
                    Demo{" "}
                  </MenuItem>
                  <MenuItem value="1" sx={{ fontSize: 14 }}>
                    Event
                  </MenuItem>
                </Select>

                <Select
                  className="text-[14px] "
                  value={eventName}
                  onChange={handleChangeEvent}
                  displayEmpty
                  renderValue={(selected) => {
                    const selectedevent =
                      viewevent &&
                      viewevent.data &&
                      viewevent.data.find((event) => event.id === selected);
                    return selectedevent ? selectedevent.name : "All Event";
                  }}
                  sx={{
                    border: "none",
                    borderRadius: "8px",
                    height: "50px",
                    fontSize: 14,
                    background: "white",
                    width: "100%",
                    minWidth: "50px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove the outline when focused
                    },
                    "& .MuiSelect-icon": {
                      color: "#000", // Customize the icon color if needed
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        marginTop: "7px",
                        borderRadius: "8px",
                      },
                    },
                  }}
                >
                  <MenuItem value={"All Event"} sx={{ fontSize: 14 }}>
                    All Event{" "}
                  </MenuItem>
                  {viewevent &&
                    viewevent.data &&
                    viewevent.data.map((obj) => (
                      <MenuItem
                        key={obj.id}
                        value={obj.id}
                        sx={{ fontSize: 14 }}
                      >
                        {obj.name}
                      </MenuItem>
                    ))}
                </Select>
              </div>
            </div>
          </div>
        )}

        {loading ? (
          <>

          {loadingGuests ? (
            <div className="flex justify-center items-center h-[300px]">
              <CircularProgress />
            </div>
          ) : (
            <div>
              <div
              className=" bg-white p-6  rounded-2xl  text-center flex flex-col  justify-items-center gap-4"
              style={{ overflowX: "auto", width: "100%", overflowY: "auto" }}
            >
              <TableContainer
                component={Paper}
                sx={{ borderRadius: "8px", minHeight: 657 }}
              >
                <Table sx={{ minWidth: 670 }} aria-label="simple table">
                  <TableHead sx={{ background: "#F6F6F6" }}>
                    <TableRow className="flex justify-between px-6">
                      {/* <div className="flex justify-between px-6"> */}
                      <TableCell>{t("guestName")}</TableCell>
                      <TableCell align="left">{t("emailId")}</TableCell>
                      <TableCell align="left">{t("phoneNumber")}</TableCell>
                      {/* <TableCell align='left'>CompanyName</TableCell> */}
                      <TableCell align="left">{t("function")}</TableCell>
                      <TableCell align="left">{t("event_name")}</TableCell>
                      <TableCell align="left">{t("sendNow")}</TableCell>
                      <TableCell align="center">{t("menu")}</TableCell>
                      {/* </div>   */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allGuests &&
                      allGuests.data &&
                      allGuests.data.data.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row" sx={{ fontWeight: 500 }}>
                            <Skeleton width="80%" />
                          </TableCell>
                          <TableCell align="left">
                            <Skeleton width="100%" />
                          </TableCell>
                          <TableCell align="left">
                            <Skeleton width="100%" />
                          </TableCell>
                          <TableCell align="left">
                            <Skeleton width="100%" />
                          </TableCell>
                          <TableCell align="left">
                            <Skeleton width="100%" />
                          </TableCell>
                          <TableCell align="center">
                            <Skeleton width="60%">
                              <button className="submit max-w-24 w-full bg-[#3686FF] text-white rounded-[8px]">
                                {t("send")}
                              </button>
                            </Skeleton>
                          </TableCell>
                          <TableCell align="right">
                            <div className="flex gap-5 justify-center">
                              <Skeleton width={20} height={20} />
                              <Skeleton width={18} height={18} />
                            </div>
                          </TableCell>
                        </TableRow>

                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              </div>
              <div className="mx-auto mt-2">
                <Pagination
                  count={viewguest?.data?.last_page}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                />
              </div>
            </div>
          )}
          </>
        ) : allGuests && allGuests.data && allGuests.data.data.length > 0 ? (
          <>
            <div
              className=" bg-white p-6  rounded-2xl  text-center flex flex-col  justify-items-center gap-4"
              style={{ overflowX: "auto", width: "100%", overflowY: "auto" }}
            >
              <TableContainer
                component={Paper}
                sx={{ borderRadius: "8px", minHeight: 657 }}
              >
                <Table sx={{ minWidth: 670 }} aria-label="simple table">
                  <TableHead sx={{ background: "#F6F6F6" }}>
                    <TableRow>
                      <TableCell>{t("guestName")}</TableCell>
                      <TableCell align="left">{t("emailId")}</TableCell>
                      <TableCell align="left">{t("phoneNumber")}</TableCell>
                      {/* <TableCell align='left'>CompanyName</TableCell> */}
                      <TableCell align="left">{t("function")}</TableCell>
                      <TableCell align="left">{t("event_name")}</TableCell>
                      <TableCell align="center">{t("sendNow")}</TableCell>
                      <TableCell align="center">{t("menu")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allGuests &&
                      allGuests.data &&
                      allGuests.data.data.map((row, i) => (
                        <TableRow
                          key={i}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ fontWeight: 500 }}
                          >
                            {`${row.first_name} ${row.last_name}`}
                          </TableCell>
                          <TableCell align="left">{row.email}</TableCell>
                          <TableCell align="left">{row.phone === '-' ? "" : row.phone}</TableCell>
                          {/* <TableCell align="left">{row.CompanyName}</TableCell> */}
                          <TableCell align="left">
                            {row.account_type === 0
                              ? "Demo"
                              : row.account_type === 1
                                ? "Event"
                                : ""}
                          </TableCell>
                          <TableCell align="left">{row.event.name}</TableCell>
                          <TableCell align="center">
                            <button
                              className={`min-w-24 max-w-24 w-full rounded-[8px] ${row.is_sent ? "bg-[#F6F6F6] text-gray-500 " : "bg-[#3686FF] text-white"}`}
                              onClick={() => handlereview(row.id, row.event.id)}
                            >
                              {row.is_sent === true ? `${t('sent')}` : `${t('send')}`}
                            </button>
                          </TableCell>

                          <TableCell align="right">
                            <div className="flex  gap-5 justify-center  ">
                              <span onClick={() => handleedit(row)}>
                                <MdOutlineEdit fill="#3686FF" size={20} className="cursor-pointer" />
                              </span>
                              <span
                                onClick={() =>
                                  handledelete(setDeleteId(row.id))
                                }
                              >
                                <RiDeleteBin6Line fill="#ED3939" size={18} className="cursor-pointer" />
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className="mx-auto mt-2">
              <Pagination
                count={viewguest?.data?.last_page}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </div>
          </>
        ) : (
          <div className="w-full  sm:h-[calc(100vh-350px)] flex justify-center items-center object-cover">
            <img
              src={notfound}
              alt="not found"
              width={500}
              className="mt-[70px]"
            />
          </div>
        )}
      </div>
      <YourGuestModal
        displayModal={displayModal}
        setDisplayModal={setDisplayModal}
      />
      <DeleteModal
        Opendel={Opendel}
        setOpendel={setOpendel}
        deleteId={deleteId}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setCachedPages={setCachedPages}
        accountType={accountType}
        eventName={eventName}
        cachedPages={cachedPages}
        debouncedSearch={debouncedSearch}
      />
      <EditModal
        Openedit={Openedit}
        setOpenedit={setOpenedit}
        guest={selectedGuest}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setCachedPages={setCachedPages}
        accountType={accountType}
        eventName={eventName}
        cachedPages={cachedPages}
        debouncedSearch={debouncedSearch}
      />
    </>
  );
};

export default YourGuests;
